import LegalLayout, { H2, P, UL } from "@/components/LegalLayout";

export default function CookiePolicy() {
  return (
    <LegalLayout
      title="Cookie Policy"
      description="How MeasureTheRoof uses cookies and similar technologies, and how to manage your preferences under the CPRA."
      path="/cookie-policy"
      updated="June 17, 2026"
    >
      <P>
        This Cookie Policy explains how MeasureTheRoof uses cookies and similar technologies, the
        categories we use, and how you can control them.
      </P>

      <H2>What are cookies?</H2>
      <P>
        Cookies are small text files stored on your device when you visit a website. They help the
        site function, remember your preferences, and understand how the site is used.
      </P>

      <H2>Categories we use</H2>
      <UL>
        <li><strong>Strictly necessary:</strong> required for sign-in, security, and core functionality. These are always active and cannot be turned off.</li>
        <li><strong>Functional:</strong> remember preferences such as recent addresses and your waste-factor settings. Enabled only with your consent.</li>
        <li><strong>Analytics & sharing:</strong> help us understand usage to improve the product. Enabled only with your consent. Opting out also opts you out of the "sale" or "sharing" of personal information under the CPRA.</li>
      </UL>

      <H2>Managing your preferences</H2>
      <P>
        You can accept, reject, or customize non-essential cookies at any time using our cookie banner.
        To reopen your choices, click <strong>"Do Not Sell or Share My Info"</strong> in the footer, or
        clear cookies in your browser settings. Your most recent choice is saved on your device.
      </P>

      <H2>Your CPRA rights</H2>
      <P>
        California residents can opt out of the sale or sharing of personal information and exercise
        other privacy rights described in our{" "}
        <a href="/privacy" className="text-orange font-semibold">Privacy Policy</a>. Opting out of the
        Analytics & sharing category through our banner serves as your opt-out signal for cookie-based
        sharing.
      </P>

      <H2>Changes</H2>
      <P>We may update this Cookie Policy from time to time. The "Last updated" date reflects the latest version.</P>

      <H2>Contact</H2>
      <P>
        Questions about cookies? Email{" "}
        <a href="mailto:privacy@measuretheroof.com" className="text-orange font-semibold">privacy@measuretheroof.com</a>.
      </P>
    </LegalLayout>
  );
}
